var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Alert, Grid, Menu, MenuItem, MenuList } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ModifyAppointmentAPI, appointmentDetailsGetByIdAPI, validateAppointmentURL } from '../../api/url';
import { FreaturedRecheduedIcon } from '../../assets/images';
import { MuiPopup, MuiStack } from '../../components';
import HeaderDetails from '../../components/atoms/headerDetails';
import SkeletonLoader from '../../components/atoms/sketeton';
import CancelSuccessfullyPopup from '../../components/molecules/cancelSuccessfullyPopup';
import UnsavedChangesPopup from '../../components/molecules/unsavedChangesPopup';
import AppointmentAssignReassignPopup from '../../components/templates/AppointmentAssignReassignPopup';
import CancelDocumentModal from '../../components/templates/cancelDocumentModal';
import { APISchema, ECancelDocSystemName, EMenuFeature, EMenuNames, EParentModuleName, ESystemName, LOCAL_STORAGE_KEYS, StatusEnum } from '../../constants';
import { showLoader, showNotification } from '../../redux/commonSlice';
import { getByIdAPI, resetState, setState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import { getLocalStorageItem } from '../../utils/storageHelper';
import { getCTAList, scrollToTop } from '../../utils/utils';
import CustomerAndVehicleInfo from '../commonViews/searchByType/customerAndVehicleInfo';
import ServiceDetailsComponent from '../commonViews/serviceDetails/serviceDetailsComponent';
import RescheduleAppointmentModal from './rescheduleAppointmentModal';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { socketIO } from '../../socket';
// import ServiceDetailsComponent from '../commonViews/serviceDetails/serviceDetailsComponent'
var AppointmentDetailsComponent = function () {
    var _documentDetailsGetBy, _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5, _documentDetailsGetBy6, _documentDetailsGetBy7, _documentDetailsGetBy8, _documentDetailsGetBy9, _documentDetailsGetBy10, _documentDetailsGetBy11, _documentDetailsGetBy12;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var id = useParams().id;
    var documentDetailsGetById = useAppSelector(function (state) { return state.crud; }).documentDetailsGetById;
    var trackButtonClick = useAnalyticsEventTracker('AppointmentDetailsComponent');
    var _a = useState(false), editCustomer = _a[0], setEditCustomer = _a[1];
    var _b = useState(), vehicleDetails = _b[0], setVehicleDetails = _b[1];
    var _c = useState(), customerDetails = _c[0], setcustomerDetails = _c[1];
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = useState(''), appointmentCode = _e[0], setAppointmentCode = _e[1];
    var _f = useState(false), cancelledSuccessfulPopup = _f[0], setCancelledSuccessfulPopup = _f[1];
    var _g = useState(false), isAssignModalOpen = _g[0], setIsAssignModalOpen = _g[1];
    var _h = useState(''), assignValue = _h[0], setAssignValue = _h[1];
    var _j = useState([]), serviceAdvisorList = _j[0], setServiceAdvisorList = _j[1];
    var _k = useState(), menus = _k[0], setMenus = _k[1];
    var _l = useState(false), cancelPopup = _l[0], setCancelPopup = _l[1];
    var _m = useState(false), reschedulePopup = _m[0], setReschedulePopup = _m[1];
    var _o = useState(true), isShowSkeleton = _o[0], setShowSkeleton = _o[1];
    var open = Boolean(anchorEl);
    // const storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE)
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var appointmentFeatures = getCTAList(storedAllMenuFeatures, EMenuNames.Appointment);
    var isDisabled = [StatusEnum.Inward, StatusEnum.Cancelled, StatusEnum.Closed].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.Key) || "") || !(documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy2 = documentDetailsGetById.data) !== null && _documentDetailsGetBy2 !== void 0 && _documentDetailsGetBy2.AssignedEmployeeId);
    var _p = useState(false), openPopup = _p[0], setOpenPopup = _p[1];
    var isDocDataUpdated = useSelector(function (state) { return state.common; }).isDocDataUpdated;
    var state = useLocation().state;
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var socketRoom = "".concat(storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId, "_").concat(storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId);
    var socket = null;
    socket = socketIO;
    useEffect(function () {
        if (socket && storedSelectedChannel !== null && storedSelectedChannel !== void 0 && storedSelectedChannel.ChannelId && storedSelectedBranch !== null && storedSelectedBranch !== void 0 && storedSelectedBranch.OrganizationId) {
            if (!socket.connected) {
                socket.connect();
            }
            socket.emit("joinRoom", socketRoom);
            socket.on("disconnect", function () {
                console.log("socket disconnected appointment details");
            });
            return function () {
                console.log("Cleaning up listener");
                socket.off("PreJobCardUpdate");
            };
        }
    }, []);
    useEffect(function () {
        if (socket && documentDetailsGetById && documentDetailsGetById.data) {
            var _socket;
            (_socket = socket) === null || _socket === void 0 || _socket.on('PreJobCardUpdate', function (data) {
                if (data.PreJobCardDocumentId === id) {
                    var updatedDocumentDetails = _objectSpread({}, documentDetailsGetById);
                    var updateData = _objectSpread(_objectSpread({}, updatedDocumentDetails === null || updatedDocumentDetails === void 0 ? void 0 : updatedDocumentDetails.data), data);
                    updateData.StatusName = data === null || data === void 0 ? void 0 : data.StatusName;
                    updateData.SourceDocumentNo = data !== null && data !== void 0 && data.SourceDocumentNo ? data === null || data === void 0 ? void 0 : data.SourceDocumentNo : updateData.SourceDocumentNo;
                    updateData.Key = data === null || data === void 0 ? void 0 : data.Key;
                    var updatedSourceMessage = _objectSpread({}, updateData.SourceMessage);
                    updatedSourceMessage.ErrorMessage = data.ErrorMessage;
                    updateData.SourceMessage = updatedSourceMessage;
                    updatedDocumentDetails.data = updateData;
                    console.log("updatedDocumentDetails", updatedDocumentDetails);
                    dispatch(setState({
                        key: "documentDetailsGetById",
                        value: updatedDocumentDetails
                    }));
                }
            });
        }
    }, [socket, documentDetailsGetById]);
    useEffect(function () {
        scrollToTop();
        documentDetailsDetails();
    }, []);
    var documentDetailsDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, result, _result$payload3, _result$payload4, _result$payload5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "documentDetailsGetById",
                            url: appointmentDetailsGetByIdAPI + id + "/Get"
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.value) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                        setShowSkeleton(false);
                        appointmenuMenuFeatureList(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                        setVehicleDetails(result !== null && result !== void 0 && (_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && _result$payload4.data ? result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.value) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.data : {});
                        setcustomerDetails(result.payload.value.data.Customer ? result === null || result === void 0 ? void 0 : result.payload.value.data.Customer : {});
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBackClick = function () {
        if (isDocDataUpdated) {
            setOpenPopup(true);
        }
        else {
            if (state !== null && state !== void 0 && state.fromRoute) {
                navigate(state === null || state === void 0 ? void 0 : state.fromRoute);
            }
            else {
                navigate('/appointment');
            }
        }
    };
    var appointmenuMenuFeatureList = function (data) {
        if (data !== null && data !== void 0 && data.AssignedEmployeeId) {
            if ((data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Inward) {
                var filterReassign = appointmentFeatures === null || appointmentFeatures === void 0 ? void 0 : appointmentFeatures.filter(function (item) { return item.Name === EMenuFeature.ReassignServiceAdvisor; });
                setMenus(filterReassign);
            }
            else {
                var filterReassign = appointmentFeatures === null || appointmentFeatures === void 0 ? void 0 : appointmentFeatures.filter(function (item) { return !(item.Name === EMenuFeature.AssignServiceAdvisor); });
                setMenus(filterReassign);
            }
        }
        else {
            if ((data === null || data === void 0 ? void 0 : data.Key) !== StatusEnum.Inward) {
                var filterAssign = appointmentFeatures === null || appointmentFeatures === void 0 ? void 0 : appointmentFeatures.filter(function (item) { return item.Name === EMenuFeature.AssignServiceAdvisor; });
                setMenus(filterAssign);
                dispatch(showNotification({
                    isOpen: true,
                    message: "Please assign service advisor to proceed.",
                    type: "error"
                }));
            }
        }
    };
    var handleClick = function (event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    var handleMenusClick = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.AssignServiceAdvisor) {
                setIsAssignModalOpen(true);
                setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.ReassignServiceAdvisor) {
                setIsAssignModalOpen(true);
                setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.Reschedule) {
                setReschedulePopup(true);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.Cancel) {
                setCancelPopup(true);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.CreateVehicleInspection) {
                dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "filterValue", "customerDetailsTrnalsteToJob", "customerComplaintDataImageAndAudio"]));
                navigate("/create-inspection/".concat(id));
            }
            return [2 /*return*/];
        });
    }); };
    var onCancelAppointmentClick = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload6, _result$payload7, _result$payload8;
        return __generator(this, function (_a) {
            if ((result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload7 = result.payload) !== null && _result$payload7 !== void 0 && _result$payload7.success) {
                dispatch(setState({
                    key: "menuValue",
                    value: 'cancel'
                }));
                onCancelPopupClick(false);
                setAppointmentCode((_result$payload8 = result.payload) === null || _result$payload8 === void 0 || (_result$payload8 = _result$payload8.data) === null || _result$payload8 === void 0 ? void 0 : _result$payload8.Code);
                setCancelledSuccessfulPopup(true);
            }
            return [2 /*return*/];
        });
    }); };
    var onCancelPopupClick = function (value) {
        setCancelPopup(value);
        setAnchorEl(null);
    };
    var onClickYesBtn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setOpenPopup(false);
            return [2 /*return*/];
        });
    }); };
    var onClickNoBtn = function () {
        navigate('/appointment');
    };
    var listVariants = [{
            id: 1,
            Name: 'General',
            DisplayName: 'General'
        }, {
            id: 2,
            Name: 'TaskDetails',
            DisplayName: 'Task Details'
        }];
    console.log("menus", menus);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(HeaderDetails, {
        headerTitle: t("Service details"),
        status: (_documentDetailsGetBy3 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.StatusName) !== null && _documentDetailsGetBy3 !== void 0 ? _documentDetailsGetBy3 : "",
        docDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.AssignedDate,
        docNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.Code,
        sourceDocumentNo: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy7 = documentDetailsGetById.data) !== null && _documentDetailsGetBy7 !== void 0 && _documentDetailsGetBy7.SourceDocumentNo ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.SourceDocumentNo : "",
        onHandleClick: handleBackClick,
        onMoreIconClick: function (event) { return handleClick(event); },
        statusKey: (_documentDetailsGetBy9 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.Key) !== null && _documentDetailsGetBy9 !== void 0 ? _documentDetailsGetBy9 : '',
        parentComponent: EParentModuleName.Appointment
    }), !isShowSkeleton && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        paddingX: 2,
        lg: 12,
        xl: 12,
        p: 2
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            border: "1px solid ".concat(systemColor.grey),
            marginRight: '-15px',
            marginLeft: '-15px'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        paddingX: 2,
        lg: 12,
        xl: 12
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, " ", (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy11 = documentDetailsGetById.data) === null || _documentDetailsGetBy11 === void 0 || (_documentDetailsGetBy11 = _documentDetailsGetBy11.SourceMessage) === null || _documentDetailsGetBy11 === void 0 ? void 0 : _documentDetailsGetBy11.ErrorMessage) && /*#__PURE__*/ React.createElement(Alert, {
        style: {
            "padding": "0 16px",
            marginBottom: "5px"
        },
        variant: "outlined",
        severity: "error"
    }, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy12 = documentDetailsGetById.data) === null || _documentDetailsGetBy12 === void 0 || (_documentDetailsGetBy12 = _documentDetailsGetBy12.SourceMessage) === null || _documentDetailsGetBy12 === void 0 ? void 0 : _documentDetailsGetBy12.ErrorMessage)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: systemColor.white,
        px: 1.5,
        border: "1px solid ".concat(systemColor.grey),
        borderRadius: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(CustomerAndVehicleInfo, {
        parentDocument: EParentModuleName.Appointment,
        VehiclesDetailsList: documentDetailsGetById ? [documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data] : [],
        customerDetails: documentDetailsGetById ? documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data : {},
        isCheckBoxVisible: false,
        isDisabled: isDisabled,
        createAndEditFlow: {
            isAppointment: "Update"
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(ServiceDetailsComponent, {
        vehicleDetails: vehicleDetails,
        customerDetails: customerDetails,
        SystemName: ESystemName.Appointment,
        parentComponent: EParentModuleName.Appointment,
        apiRequestPayload: {
            AppointmentId: id
        },
        module: APISchema.Appointment,
        parentModuleDocumentId: id !== null && id !== void 0 ? id : "",
        errorMessage: true,
        modifyDocumentURL: ModifyAppointmentAPI(id !== null && id !== void 0 ? id : ""),
        validateDocumentURL: validateAppointmentURL,
        isDisabled: isDisabled,
        createAndEditFlow: {
            isAppointment: "Update"
        }
    }))))), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB',
                    right: 30,
                    width: 'fit-content'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        minWidth: "270px"
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: item.Name,
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === menus.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: 500,
                fontSize: 14,
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize'
            },
            onClick: function (event) {
                trackButtonClick("ButtonClickEvent", "".concat(item === null || item === void 0 ? void 0 : item.Name) + "_AppointmentDetails_Click", undefined);
                handleMenusClick(item);
                //handleClose(event)
                setAnchorEl(null);
            }
            //disabled={isDisabled}
        }, item.DisplayName);
    }))))), isAssignModalOpen && /*#__PURE__*/ React.createElement(AppointmentAssignReassignPopup, {
        isOpen: isAssignModalOpen,
        onClosed: function () {
            setIsAssignModalOpen(false);
            setAnchorEl(null);
            documentDetailsDetails();
        },
        data: assignValue,
        appointmentData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        moduleName: "Appointment"
    }), cancelPopup && /*#__PURE__*/ React.createElement(CancelDocumentModal, {
        cancelPopup: cancelPopup,
        data: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        title: t("Cancel appointment"),
        subTitle: t("Are you sure you want to cancel this appointment? This action cannot be undone."),
        onCancelPopup: function (value) { return onCancelPopupClick(value); },
        onCancelClick: function (result) { return onCancelAppointmentClick(result); },
        SystemName: ECancelDocSystemName.Appointment
    }), reschedulePopup && /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: reschedulePopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            setReschedulePopup(false);
            setAnchorEl(null);
        },
        padding: "15px 0px 0px 15px",
        headerIcon: FreaturedRecheduedIcon,
        containerStyle: {
            padding: "15px"
        },
        showLoaderOnPopup: true
    }, /*#__PURE__*/ React.createElement(RescheduleAppointmentModal, {
        onReschedulePopup: function (value) {
            setReschedulePopup(value);
            setAnchorEl(null);
        },
        data: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data
    })), cancelledSuccessfulPopup && /*#__PURE__*/ React.createElement(CancelSuccessfullyPopup, {
        documentCode: appointmentCode,
        successfulPopup: cancelledSuccessfulPopup,
        onClosePopup: function (value) {
            setCancelledSuccessfulPopup(value);
            navigate("/appointment");
        },
        title: t('Successfully cancelled!'),
        subTitle: "Appointment ".concat(appointmentCode, " has been successfully cancelled")
    }), /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: openPopup,
        onClosePopup: function (value) { return setOpenPopup(value); },
        onClickNoBtn: onClickNoBtn,
        onClickYesBtn: onClickYesBtn
    })), isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '70vh',
            padding: "10px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)));
};
export default AppointmentDetailsComponent;
